
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'ztn-radio',
  props: {
    options: Array,
    disabled: Boolean,
    vertical: Boolean,
    value: [String, Number, Boolean],
    gap: Number,
    button: Boolean,
    buttonType: String as () => 'outline' | 'solid',
    size: {
      type: String as () => 'small' | 'medium' | 'large',
      default: 'medium'
    },
    color: {
      type: String,
      default: 'var(--base-primary-1)'
    }
  },
  computed: {
    sum() {
      return this.options?.length
    },
    styleObject() {
      if (this.vertical) {
        return {
          marginBottom: this.gap + 'px'
        }
      } else {
        return {
          marginRight: this.gap + 'px'
        }
      }
    },
    radioStyle() {
      return {
        '--radio-color': this.color
      }
    },
    sizeClass() {
      return this.size ? `z-radio-${this.size}` : ''
    }
  },
  emits: ['update:value', 'change'],
  methods: {
    onClick(value: any) {
      if (value !== this.value) {
        this.$emit('update:value', value)
        this.$emit('change', value)
      }
    }
  }
})
